export function getOptions() {
  let top = "top" as const;
  return {
    origin: top,
    distance: '80px',
    duration: 2000,
    reset: true
  }
}
